import { Carousel, Form } from 'antd';
import clsx from 'clsx';
import chunk from 'lodash/chunk';
import React, { useMemo } from 'react';
import { ICategoryItemData, IServiceItemData } from 'services/shop/types/categories';
import styled from 'styled-components';
import padListToFillColumns from 'utils/padListToFillColumns';
import uuid from 'utils/uuid';
import ic_add from './assets/ic_add.svg';
import ic_minus from './assets/ic_minus.svg';
import ic_tick_white from './assets/tick-white.svg';
import ic_tick from './assets/tick.svg';
import { formatCurrency } from 'utils/formatCurrency';
import shopSelectors from 'services/shop/selectors';
import { IFormValueServiceItem } from './types';
import { Row } from 'components/Box/Row';
const img_tick = <img src={ic_tick} alt="ic_tick" style={{ width: 24, height: 24 }} />;
const img_tick_white = <img src={ic_tick_white} alt="ic_tick_white" style={{ width: 24, height: 24 }} />;

type ServicesProps = {
  services: IServiceItemData[];
  value?: IFormValueServiceItem[];
  onChange?: (value: IFormValueServiceItem[]) => void;
  v4?: boolean;
};
export const ServicesUI = ({ services, value: selected, onChange, v4 }: ServicesProps) => {

  const allShopSetting = shopSelectors.data.allShopSetting();

  const form = Form.useFormInstance();
  const onAdd = (o: IServiceItemData) => (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    const values = [...selected || []];
    const result: IFormValueServiceItem = {
      id: o.id,
      catId: o.catId,
      duration: o.duration,
      serviceName: o.serviceName,
      staffName: '',
      staffId: '',
      local_uuid: uuid(),
      staffAvatar: '',
      startTime: '',
      endTime: '',
      price: o.priceSell,
    };
    values.push(result);
    form.resetFields(['SERVICE_VALID']);
    onChange?.(values);
  };
  const onMinus = (o: IServiceItemData) => (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    const values = [...selected || []];
    const idx = values.findIndex(a => a.id === o.id);
    if (idx == -1) return;
    values.splice(idx, 1);
    form.resetFields(['SERVICE_VALID']);
    onChange?.(values);
  };

  return (
    <ServicesContainer>
      <p className="service-title">Select services</p>
      <div className="service-list">
        {services.map(o => {
          const length = selected?.filter(s => s.id === o.id)?.length || 0;
          return (
            <button type='button' key={o.id} className={`service-item ${!!length && 'active'}`} onClick={onAdd(o)} >
              <div className="service-name-box">
                <Row gap='2' alignItems='center'>
                  <span className="service-name">{o.serviceName}</span>
                  {v4 && <span className="service-duration">({o.duration}m)</span>}
                </Row>
                {allShopSetting?.displayPriceServiceBooking && !v4 && <span className="service-price">{formatCurrency(o.priceSell)}</span>}
                {v4 && <span className="service-price">{formatCurrency(o.priceSell)}</span>}
              </div>
              <div className="service-actions">
                <button onClick={onMinus(o)} type='button' className='action-item'>
                  <img src={ic_minus} alt="ic_minus" />
                </button>
                <p className='name'><span>{length}</span></p>
                <button onClick={onAdd(o)} type='button' className='action-item'>
                  <img src={ic_add} alt="ic_add" />
                </button>
              </div>
            </button>
          );
        })}
      </div>
    </ServicesContainer>
  );
};
const ServicesContainer = styled.div`
p.service-title {
  color: #64748B;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.service-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.service-item {
  display: flex;
  padding: 8px;
  justify-content: center;
  align-items: center;
  align-self: stretch;
  border-radius: 5px;
  background:  #FFF;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.25);
  border:  1px solid transparent;

  .service-name-box {
    display: flex;
    align-items: flex-start;
    flex-direction: column;
    gap: 4px;
    flex: 1 0 0;
  }
  span.service-name {
    color: #1D2129;
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  span.service-duration {
    color: #566A7F;
    font-family: Poppins;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  p.name {
    display: flex;
    width: 24px;
    height: 24px;
    flex-direction: column;
    justify-content: center;
    span {
      color: #2463EB;
      text-align: center;
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }

  &.active {
    border:  1px solid #2463EB;
    background: rgba(215, 237, 255, 0.3);
  }


  .service-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    .action-item {
      display: flex;
      align-items: center;
      img {
        width: 40px;
        height: 40px;
      }

      &:active {
        opacity: 0.6;
      }
    }
  }
}
`;

type CategoriesProps = {
  activeId?: string;
  categories: ICategoryItemData[];
  value?: IFormValueServiceItem[];
  onChooseCate: (category: ICategoryItemData) => void;
};
export const CategoriesUI = ({ categories, value: selectedServices = [], activeId = '', onChooseCate }: CategoriesProps) => {

  return (
    <Container>
      {categories.map(o => {
        if (!o) return <CategoryItem style={{ opacity: 0 }} />;
        const selected = selectedServices.filter(s => s.catId === o.id).length;
        const active = o.id === activeId;
        return (
          <CategoryItem onClick={() => onChooseCate(o)} type='button' key={o.id} className={clsx(selected && 'selected', active && 'active')}>
            {selected ? (active ? img_tick_white : img_tick) : null}
            <p className='name'>{o.categoryName}</p>
            {!!selected && <span className="selected">{selected} services</span>}
          </CategoryItem>
        );
      })}
    </Container>
  );
};

const CategoryItem = styled.button`
display: flex;
min-height: 65px;
padding: 0px 16px;
flex-direction: column;
justify-content: center;
align-items: center;
flex: 1 0 0;
border-radius: 14px;
border: 1px solid #CCD4DC;
background: #F6F7FC;
p.name {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 137.5%;
  letter-spacing: 0.32px;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: initial;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
span.selected {
  color: #1D2129;
  text-align: center;
  font-family: Poppins;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 100%; /* 12px */
  letter-spacing: 0.24px;
}


&.selected {
  border: 1px solid #2463EB;
  background: #EEF4FF;
}
&.active {
  background: #2463EB;
  .selected, .name {
    color: #fff;
  }
  
}

  @media (max-width: 768px) {
    min-height: 54px;
    border-radius: 8px;
    padding: 0;
    p.name {
      font-size: 14px;
    }

    span.selected {
      font-size: 10px;
    }

    >img {
      width: 16px!important;
      height: 16px!important;
    }
  }
`;

const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;

  @media (max-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
  }
`;